import { useDeviceSize } from '@libs/utils/hooks/useDeviceSize';
import { useLocation } from 'react-router-dom';
import { useRedline } from '@libs/redline';
import classNames from 'classnames';

import { getHomePath } from '@libs/renegkit/experiments/RKOffersListing';
import { Text } from '@consumidor-positivo/aurora';
import { AppNavButtons } from './data';

import './styles.scss';

export const CpAppNavigation = ({ buttons = AppNavButtons }) => {
  const { track: trackRedline } = useRedline();
  const { isDesktop } = useDeviceSize();
  const location = useLocation();
  const homePath = getHomePath();

  // dx-rk-offers-listing: resolve the "Dívidas" entry to /inicio for the variant so the tab
  // navigates there and its active-state matches the current route.
  const resolvedButtons = buttons.map((button) => (button.path === '/minhas-dividas' ? { ...button, path: homePath } : button));

  const paths = resolvedButtons.map(({ path }) => path);

  const handleCpAppNavigationClick = (path: string) => {
    const indexMap: Record<string, string> = {
      '/meu-score': 'score',
      '/minhas-ofertas': 'credito',
      '/minhas-dividas': 'dividas',
      '/inicio': 'dividas',
    };

    const name = indexMap[path];

    trackRedline.userTracking.elementClicked({
      elementType: 'content',
      location: '/inicio',
      position: 'dashboard-tab',
      name: name,
    });

    window.location.href = path;
  };

  if (!paths.includes(location.pathname) || isDesktop) {
    return null;
  }

  return (
    <div className="cp-app-navigation">
      <nav className="cp-app-navigation__nav">
        {resolvedButtons.map(({ label, path, icon }) => {
          const isActive = location.pathname === path;
          return (
            <div
              key={path}
              className={classNames('cp-app-navigation__action', {
                'cp-app-navigation__action--active': isActive,
              })}
              onClick={() => handleCpAppNavigationClick(path)}
            >
              <div
                className={classNames('cp-app-navigation__indicator', {
                  'cp-app-navigation__indicator--active': isActive,
                })}
              />
              {icon}
              <Text as="p" variant="caption">
                {label}
              </Text>
            </div>
          );
        })}
      </nav>
    </div>
  );
};
